import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";

const FireWorkUnit = ({
  id = "48Tkp_uK3u3QX6tMK5qyB3FGzk36aqYi",
  className = "container",
  title = "Short Videos",
  showTitle = true
}) => {
  return (
    <div className={`${className}`}>
      {showTitle && <h2 className={`${styles.headline}`}>{title}</h2>}
      <fw-embed-feed app_id={id} mode="row" open_in="default" max_videos="20" placement="middle" />
    </div>
  );
};

FireWorkUnit.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  showTitle: PropTypes.bool
};

export default FireWorkUnit;
